angular.module 'app'
.config ($stateProvider) ->
  $stateProvider
    .state 'app.wechat',
      url: '/wechat'
      templateUrl: 'apps/wechat/wechat'
      controller: 'WechatCtrl'
